import { IInitialCatalogTarifsState } from 'interfaces/catalogTarifs.interface';

const initialCatalogTarifsState: IInitialCatalogTarifsState = {
  getCatalogTarifs: () => Promise.resolve(false),
  catalogTarifs: [],
  isLoadingCatalogTarifs: false,
  resetCatalogTarifs: () => {},
  tarifSelected: null,
  selectTarif: () => Promise.resolve(false),
  createTarif: () => Promise.resolve(false),
  isLoadingCreateTarif: false,
  updateTarif: () => Promise.resolve(false),
  isLoadingUpdateTarif: false,
  deleteTarif: () => Promise.resolve(false),
  isLoadingDeleteTarif: {
    tarifId: '',
    isLoading: false,
  },
  downloadTarif: () => Promise.resolve(false),
  isLoadingDownloadTarif: false,
};

export default initialCatalogTarifsState;
